import { render } from "./storeInfoDetail.vue?vue&type=template&id=88156f38&scoped=true"
import script from "./storeInfoDetail.vue?vue&type=script&lang=js"
export * from "./storeInfoDetail.vue?vue&type=script&lang=js"

import "./storeInfoDetail.vue?vue&type=style&index=0&id=88156f38&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-88156f38"]])

export default __exports__